import { render, staticRenderFns } from "./TaskRequest.vue?vue&type=template&id=133f9f61&"
import script from "./TaskRequest.vue?vue&type=script&lang=js&"
export * from "./TaskRequest.vue?vue&type=script&lang=js&"
import style0 from "./TaskRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports